import React, { useRef, useState } from 'react';

export default function DropZone({
  onFile,
  disabled = false,
  accept = 'image/',
  label = 'Drop image to upload',
  children,
  style,
  overlayStyle,
}) {
  const [over, setOver] = useState(false);
  const depthRef = useRef(0);

  const reset = () => {
    depthRef.current = 0;
    setOver(false);
  };

  const handleDragEnter = (e) => {
    if (disabled) return;
    if (!hasFiles(e)) return;
    e.preventDefault();
    e.stopPropagation();
    depthRef.current += 1;
    setOver(true);
  };

  const handleDragOver = (e) => {
    if (disabled) return;
    if (!hasFiles(e)) return;
    e.preventDefault();
    e.stopPropagation();
    if (e.dataTransfer) e.dataTransfer.dropEffect = 'copy';
  };

  const handleDragLeave = (e) => {
    if (disabled) return;
    e.preventDefault();
    e.stopPropagation();
    depthRef.current = Math.max(0, depthRef.current - 1);
    if (depthRef.current === 0) setOver(false);
  };

  const handleDrop = (e) => {
    if (disabled) return;
    e.preventDefault();
    e.stopPropagation();
    reset();
    const file = e.dataTransfer?.files?.[0];
    if (file && onFile) onFile(file);
  };

  return (
    <div
      onDragEnter={handleDragEnter}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
      style={{ position: 'relative', ...(style || {}) }}
    >
      {children}
      {over && (
        <div
          style={{
            position: 'absolute',
            inset: 0,
            border: '2px dashed var(--orange, #dc582a)',
            borderRadius: 6,
            background: 'rgba(220, 88, 42, 0.08)',
            color: 'var(--orange, #dc582a)',
            fontWeight: 600,
            fontSize: 13,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            pointerEvents: 'none',
            zIndex: 5,
            textAlign: 'center',
            padding: 8,
            ...(overlayStyle || {}),
          }}
        >
          {label}
        </div>
      )}
    </div>
  );
}

function hasFiles(e) {
  const types = e.dataTransfer?.types;
  if (!types) return false;
  for (let i = 0; i < types.length; i++) {
    if (types[i] === 'Files') return true;
  }
  return false;
}
